import React from "react"
import ReactDOM from "react-dom"
import "core-js/stable"
import "regenerator-runtime/runtime"
import "isomorphic-fetch"
import "es6-promise"
import "./index.css"
import App from "./App"
import registerServiceWorker from "./registerServiceWorker"
import { BrowserRouter as Router } from "react-router-dom"
import { logger } from "redux-logger"
import promise from "redux-promise-middleware"
import { loadingBarMiddleware } from "react-redux-loading-bar"
import thunk from "redux-thunk"
import i18n from "./i18n"
import { I18nextProvider } from "react-i18next"
import { createStore, applyMiddleware, compose } from "redux"
import { Provider } from "react-redux"
import reducer from "./reducers"
const mware = [promise, thunk, loadingBarMiddleware()]
let composeEnhancers = compose
if (process.env.NODE_ENV !== "production") {
	mware.push(logger)
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
}
const store = createStore(
	reducer,
	{},
	composeEnhancers(applyMiddleware(...mware))
)

ReactDOM.render(
	<Router>
		<Provider store={store}>
			<I18nextProvider i18n={i18n}>
				<App />
			</I18nextProvider>
		</Provider>
	</Router>,
	document.getElementById("root")
)

registerServiceWorker()
